// extracted by mini-css-extract-plugin
export default {"main-container":"pages-layout_main-container__qiAb-","body-container":"pages-layout_body-container__McJ5y","scroll-container":"pages-layout_scroll-container__8FQ9m"};